/**
 * Hook for updating AI workflow nodes
 *
 * Allows editing node metadata, prompts, and configuration before execution.
 */

import { useState } from 'react';
import axios from 'axios';

/**
 * Hook to update a workflow node
 *
 * @param {string} workflowId - The workflow ID
 * @returns {Object} - Update function and state
 */
export function useAIWorkflowNodeUpdate(workflowId) {
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);

  const updateNode = async (nodeId, updates) => {
    setUpdating(true);
    setError(null);

    try {
      const response = await axios.patch(
        `/api/workflows/${workflowId}/nodes/${nodeId}`,
        updates
      );
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail || err.message || 'Failed to update node';
      setError(new Error(errorMessage));
      throw new Error(errorMessage);
    } finally {
      setUpdating(false);
    }
  };

  return {
    updateNode,
    updating,
    error
  };
}
